import { SystemField } from "./system-field";

export class TheoryCollection extends SystemField{
     
     payment_method_id?:string;
     amount?:number;
     staff_shifts_id?:string;
     transaction_date?:string;
}
